import React from 'react';
import { RESILIENCE_PRIORITY_PALETTE } from '../../lib/resiliencePriorityColors';
import { LegendCard } from './LegendCard';
import { CategoricalLegend } from './CategoricalLegend';

/**
 * Floating legend for the Resilience Priority spectrum overlay. 5-tier
 * RdYlGn ramp keyed by the published WHP × RD decision matrix on private
 * timberland. Same color ramp as the WHP layer so the spectrum reads as a
 * fire-risk gradient — green = watch, red = top priority for resilience
 * thinning.
 */
export const ResiliencePriorityMapLegend: React.FC = () => (
  <LegendCard title="Resilience priority — tier" positioned className="max-w-[360px]">
    <CategoricalLegend
      palette={RESILIENCE_PRIORITY_PALETTE}
      rowClassName="flex items-center gap-x-3 gap-y-1 flex-wrap"
    />
    <p className="mt-2 text-[10px] font-roboto text-neutral-500 italic leading-snug">
      WHP × RD decision matrix on private timberland (family + corporate)
    </p>
  </LegendCard>
);
